/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { Server } from '../../../core/models/common/Server';
import { ServerVariable } from '../../../core/models/common/ServerVariable';
import { IVisitor } from '../../../core/visitors/IVisitor';
import { IOas30Visitor } from '../visitors/IOas30Visitor';

/**
 * Constructor.
 * @class
 * @extends Server
 * @author eric.wittmann@gmail.com
 */
export class Oas30Server extends Server {
    public constructor() {
        super();
    }

    /**
     * @see io.apicurio.datamodels.core.models.Node#accept(io.apicurio.datamodels.core.visitors.IVisitor)
     * @param {*} visitor
     */
    public accept(visitor : IVisitor) {
        let viz : IOas30Visitor = <IOas30Visitor><any>visitor;
        viz.visitServer(this);
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.Server#createServerVariable(java.lang.String)
     * @param {string} name
     * @return {ServerVariable}
     */
    public createServerVariable(name : string) : ServerVariable {
        let variable : Oas30ServerVariable = new Oas30ServerVariable(name);
        variable._ownerDocument = this.ownerDocument();
        variable._parent = this;
        return variable;
    }
}
Oas30Server["__class"] = "io.apicurio.datamodels.openapi.v3.models.Oas30Server";
Oas30Server["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable"];





import { Oas30ServerVariable } from './Oas30ServerVariable';

